//organizar os imports por tipo css ou js e externo e internos ?
import React, { useEffect } from 'react';
// import 'bootstrap/scss/bootstrap.scss';
import MainFrame from './components/frames/MainFrame/MainFrame';
import { KskProvider } from 'ksk/styledComponents/KskContext';
import { ToastContainer } from 'react-toastify';
import { loadVLibras } from './utils/loadVLibras';

import 'react-toastify/dist/ReactToastify.min.css';

import { ConfirmationDialogProvider } from 'components/Dialog/ConfirmationDialog';
import AuthProvider from 'auth/AuthContext';
import useGlobalStamper from 'localization/useGlobalStamper';
import useGlobalMessages from 'localization/useGlobalMessages';
import { ToastProvider } from 'contexts/ToastContext';

//pq ConfirmationDialogProvider agrupa mainframe? semanticamente estranho?
function App() {
  useGlobalStamper();
  useGlobalMessages();

 useEffect(() => {
    loadVLibras();
  }, []);

  return (
    <>
      <KskProvider>
        <AuthProvider>
            <ConfirmationDialogProvider>
              <ToastProvider>
                <MainFrame />
              </ToastProvider>
            </ConfirmationDialogProvider>
          </AuthProvider>
      </KskProvider>
    </>
  );
}

export default App;
